import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import { ProjectsDashboardContext } from 'components/contexts/ProjectsDashboardContext';
import ProjectsDashboard from 'components/projectsDashboard/components/ProjectsDashboard';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <ProjectsDashboardContext.Provider value={{ ...wrappedProps }}>
          <ProjectsDashboard />
        </ProjectsDashboardContext.Provider>
      </AppWrapper>
    </QueryClientProvider>
  );
}
